export default __webpack_public_path__ + "static/media/D_Other.dea05b55.svg";